import * as React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import SortOrderContext from '@jetshop/core/components/SortOrder/SortOrderContext';
import t from '@jetshop/intl';
import { pushHistory } from '@jetshop/core/components/Filters/utils/updateHistory';
// Temporary sort type mapping until API returns this
export const sortTypes = {
    NAME: 'string',
    ARTICLE_NUMBER: 'number',
    PUBLISH_DATE: 'date',
    PRICE: 'number',
    SUB_HEADING: 'string',
    BESTSELLER: 'custom',
    CUSTOM: 'custom'
};
export const sortValues = {
    string: [
        {
            text: t('A to Z'),
            direction: 'ASCENDING'
        },
        {
            text: t('Z to A'),
            direction: 'DESCENDING'
        }
    ],
    number: [
        {
            text: t('low to high'),
            direction: 'ASCENDING'
        },
        {
            text: t('high to low'),
            direction: 'DESCENDING'
        }
    ],
    date: [
        {
            text: t(''),
            direction: 'DESCENDING'
        }
    ],
    custom: [
        {
            text: t(''),
            direction: 'DESCENDING'
        }
    ]
};
class SortOrderContainer extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = (value, direction) => {
            const { location, history } = this.props;
            const currentSearch = qs.parse(location.search, { ignoreQueryPrefix: true }) || {};
            const newSearch = Object.assign(Object.assign({}, currentSearch), { orderBy: value, direction });
            pushHistory({
                history,
                pathname: location.pathname,
                hash: location.hash,
                search: newSearch,
                resetPage: true,
                routeType: 'sortOrderChange'
            });
            this.setState({ sortOrder: value, direction });
            return true;
        };
        this.state = {
            sortOrder: null,
            direction: 'DESCENDING',
            changeSortOrder: this.onSelect
        };
    }
    componentDidMount() {
        if (this.props.location.search) {
            const search = qs.parse(this.props.location.search, {
                ignoreQueryPrefix: true
            });
            if (Object.keys(search).includes('orderBy')) {
                this.setState({
                    sortOrder: search.orderBy,
                    direction: search.direction
                });
            }
        }
    }
    render() {
        return (React.createElement(SortOrderContext.Provider, { value: this.state }, this.props.children(this.state)));
    }
}
export default withRouter(SortOrderContainer);
//# sourceMappingURL=SortOrderContainer.js.map